const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/offers/$id/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { httpClient } from "@/lib/http-client";
import { bestCollectionKey } from "@/lib/performance";
import { getOfferIgdb } from "@/queries/igdb";
import { getOfferPriceFairness } from "@/queries/offer-price-fairness";
export const Route = createFileRoute("/{-$locale}/offers/$id/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context,
    cause
  }) => {
    const {
      id
    } = params;
    const {
      country,
      queryClient
    } = context;
    const isPreload = cause === "preload";
    let defaultCollection = "top-sellers";
    if (!isPreload) {
      queryClient.fetchQuery({
        queryKey: ["offer", "genres", {
          id
        }],
        queryFn: () => httpClient.get<Tag[]>(`/offers/${id}/genres`).catch(() => [])
      }).catch(() => {});
      queryClient.fetchQuery({
        queryKey: ["price-stats", {
          id,
          country
        }],
        queryFn: () => httpClient.get<{
          current: Price | null;
          lowest: Price | null;
          lastDiscount: Price | null;
        }>(`/offers/${id}/price-stats`, {
          params: {
            country
          }
        }).catch(() => ({
          current: null,
          lowest: null,
          lastDiscount: null
        }))
      }).catch(() => {});
      queryClient.fetchQuery(getOfferIgdb(id)).catch(() => {});
      queryClient.fetchQuery(getOfferPriceFairness(id, country || "US")).catch(() => {});
    }

    // Fetch the tops data
    const tops = await queryClient.ensureQueryData({
      queryKey: ["offer", "tops", {
        id
      }],
      queryFn: () => httpClient.get<{
        [key: string]: number;
      }>(`/offers/${id}/tops`).catch(() => null)
    });

    // Calculate the default collection
    defaultCollection = bestCollectionKey(tops, "top-sellers");
    await queryClient.prefetchQuery({
      queryKey: ["collection", "positions", {
        id,
        collection: defaultCollection
      }],
      queryFn: () => httpClient.get<OfferPosition>(`/offers/${id}/collections/${defaultCollection}`, {
        params: {
          country
        }
      }).catch(() => null)
    });
    return {
      id,
      country,
      defaultCollection
    };
  }
});